<ng-container style="height:100%;width:100%;">
	<wa-page style="height:100%;width:100%;">
		<main>
			<router-outlet></router-outlet>
		</main>
		<header slot="header">
			<div class="wrapper-nav-products">
				<nav aria-label="DevSuite Products" class="nav-products nav-products-full">
					<div class="nav-products-primary wa-split wa-align-items-stretch">
						<div class="wa-cluster wa-align-items-stretch wa-gap-0">
							<wa-button appearance="plain" class="product product-jwebmp product-active" id="product-jwebmp" routerLink="/home" size="small" variant="brand">
								<wa-icon class="fak fa-jwebmp-logo logo-icon logo-jwebmp" label="JWebMP" name="com_jwebmp_webawesome_components_icon_WaIcon"></wa-icon>JWebMP
							</wa-button>
							<wa-button appearance="plain" class="product product-guicedee" href="https://guicedee.com" id="product-guicedee" size="small" target="guicedee" variant="brand">
								<wa-icon class="fak fa-guicedee-logo logo-icon logo-guicedee" label="GuicedEE" name="com_jwebmp_webawesome_components_icon_WaIcon"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-guicedee">GuicedEE</wa-tooltip>
							<wa-button appearance="plain" class="product product-entity-assist" href="https://entityassist.com" id="product-entity-assist" size="small" target="entityassist" variant="brand">
								<wa-icon class="fak fa-entityassist-logo logo-icon logo-entity-assist" label="Entity Assist" name="com_jwebmp_webawesome_components_icon_WaIcon"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-entity-assist">Entity Assist</wa-tooltip>
							<wa-button appearance="plain" class="product product-activity-master" href="https://activity-master.com/" id="product-activity-master" size="small" target="activitymaster" variant="brand">
								<wa-icon class="fak fa-activity-master-logo logo-icon logo-activity-master" label="Activity Master" name="com_jwebmp_webawesome_components_icon_WaIcon"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-activity-master">Activity Master</wa-tooltip>
							<wa-badge class="version-badge" id="version-badge" pill style="background-color:var(--wa-color-brand-fill-normal);border:2px solid var(--wa-color-brand-light);box-shadow:0 0 6px color-mix(in srgb, var(--wa-color-brand-normal) 40%, transparent);color:var(--wa-color-brand-on-normal);cursor:pointer;font-size:var(--wa-font-size-2xs);" variant="brand">2.0.0-SNAPSHOT</wa-badge>
							<wa-popover for="version-badge" id="jw5a4c45" placement="bottom" style="--arrow-color:var(--wa-color-brand-normal);--border-color:var(--wa-color-brand-normal);--border-radius:var(--wa-border-radius-l);--border-width:var(--wa-border-width-s);--max-width:32rem;">
								<div style="padding:var(--wa-space-m);">
									<strong style="display:block;font-size:var(--wa-font-size-m);margin-block-end:var(--wa-space-s);">Snapshot Repository Setup</strong>
									<p [innerText]="useGradle ? 'Add to your build.gradle:' : 'Add to your pom.xml:'" style="color:var(--wa-color-neutral-700);font-size:var(--wa-font-size-s);margin-block-end:var(--wa-space-s);"></p>
									@if (!useGradle) {
										<markdown [data]="mdContent_0" class="aside-snippet-code wa-body-xs" clipboard></markdown>
									}
									@if (useGradle) {
										<markdown [data]="mdContent_1" class="aside-snippet-code wa-body-xs" clipboard></markdown>
									}
									<p style="color:var(--wa-color-neutral-600);font-size:var(--wa-font-size-2xs);margin-block-start:var(--wa-space-s);">&#x1F511; GitHub Packages requires authentication — use a personal access token with <code>read:packages</code> scope.</p>
								</div>
							</wa-popover>
						</div>
						<div class="nav-products-secondary wa-cluster wa-gap-2xs">
							<div class="wa-cluster wa-gap-2xs wa-align-items-center" style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">
								<span>Maven</span>
								<wa-switch (ngModelChange)="onBuildToolChange($event)" [(ngModel)]="useGradle" name="useGradle" size="small"></wa-switch>
								<span>Gradle</span>
							</div>
							<wa-button appearance="plain" class="pseudo-product product-github" href="https://github.com/GedMarc/JWebMP" id="product-github" target="_blank" variant="brand">
								<wa-icon family="brands" label="GitHub" name="github"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-github">GitHub</wa-tooltip>
							<wa-button appearance="plain" class="pseudo-product product-star" href="https://github.com/GedMarc/JWebMP/stargazers" id="product-star" target="_blank" variant="brand">
								<wa-icon family="sharp-duotone" label="Star this Repository" name="star"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-star">Star this Repository</wa-tooltip>
							<wa-button appearance="plain" class="pseudo-product product-docs" href="https://github.com/GuicedEE/ai-rules" id="product-docs" target="_blank" variant="brand">
								<wa-icon family="sharp-duotone" label="AI Skills Repository" name="brain-circuit"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-docs">AI Skills Repository</wa-tooltip>
							<wa-button appearance="plain" class="pseudo-product product-patreon" href="https://www.patreon.com/GedMarc" id="product-patreon" target="jwebmp-patreon" variant="brand">
								<wa-icon family="brands" label="Patreon" name="patreon"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-patreon">Support me on Patreon</wa-tooltip>
							<wa-button (click)="toggleDarkMode()" appearance="plain" class="pseudo-product product-theme" id="product-theme" variant="brand">
								<wa-icon [name]="darkMode() ? 'sun-bright' : 'moon'" family="sharp-duotone" label="Toggle Theme" name="com_jwebmp_webawesome_components_icon_WaIcon"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-theme">Toggle Theme</wa-tooltip>
						</div>
					</div>
				</nav>
			</div>
		</header>
		<div slot="menu">
			<wa-tree style="--indent-guide-color:var(--wa-color-neutral-300);--indent-size:2px;">
				<wa-tree-item>
					<a href="#" routerLink="/home">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="house" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Home
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/about">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="circle-info" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;About
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/getting-started">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="rocket" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Getting Started
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/architecture">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="sitemap" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Architecture
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/plugins">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="puzzle-piece" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Plugins
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/frameworks">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="layer-group" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;UI Frameworks
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/capabilities">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="star" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Capabilities
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/real-time">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="bolt" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Data
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="https://www.patreon.com/GedMarc" target="jwebmp-external">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="life-ring" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Support
					</a>
				</wa-tree-item>
			</wa-tree>
			<div style="border-top:1px solid var(--wa-color-neutral-200);margin-top:auto;padding:var(--wa-space-m);">
				<span class="wa-body-2xs" style="color:var(--wa-color-text-quiet);display:block;margin-bottom:var(--wa-space-xs);">Built on</span>
				<div class="wa-stack wa-gap-2xs built-on-links">
					<a class="wa-body-xs" href="https://www.npmjs.com/package/angular-awesome" style="color:var(--wa-color-brand-normal);" target="angular-awesome">
						<wa-icon family="brands" name="npm"></wa-icon>Angular Awesome
					</a>
					<a class="wa-body-xs" href="https://www.webawesome.com" style="color:var(--wa-color-brand-normal);" target="web-awesome">
						<wa-icon family="sharp-duotone" name="web-awesome"></wa-icon>Web Awesome
					</a>
					<a class="wa-body-xs" href="https://guicedee.com" style="color:var(--wa-color-brand-normal);" target="guicedee">
						<i class="fak fa-guicedee-logo built-on-logo"></i>GuicedEE
					</a>
				</div>
			</div>
		</div>
		<div slot="navigation-toggle">
			<wa-button appearance="plain" aria-label="Toggle navigation menu" variant="neutral">
				<wa-icon family="sharp-duotone" name="bars"></wa-icon>
			</wa-button>
		</div>
		<div slot="navigation-toggle-icon">
			<wa-icon family="sharp-duotone" name="bars"></wa-icon>
		</div>
		<nav slot="navigation-header">
			<a aria-label="JWebMP Home" class="appearance-plain" routerLink="/home">
				<i class="fak fa-jwebmp-logo logo-icon logo-jwebmp"></i>JWebMP
			</a>
		</nav>
		<nav slot="navigation">
			<wa-tree style="--indent-guide-color:var(--wa-color-neutral-300);--indent-size:2px;">
				<wa-tree-item>
					<a href="#" routerLink="/home">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="house" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Home
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/about">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="circle-info" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;About
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/getting-started">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="rocket" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Getting Started
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/architecture">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="sitemap" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Architecture
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/plugins">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="puzzle-piece" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Plugins
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/frameworks">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="layer-group" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;UI Frameworks
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/capabilities">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="star" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Capabilities
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/real-time">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="bolt" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Data
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="https://www.patreon.com/GedMarc" target="jwebmp-external">
						<wa-icon class="wa-gap-1" family="sharp-duotone" name="life-ring" style="color:var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Support
					</a>
				</wa-tree-item>
			</wa-tree>
			<div style="border-top:1px solid var(--wa-color-neutral-200);margin-top:auto;padding:var(--wa-space-m);">
				<span class="wa-body-2xs" style="color:var(--wa-color-text-quiet);display:block;margin-bottom:var(--wa-space-xs);">Built on</span>
				<div class="wa-stack wa-gap-2xs built-on-links">
					<a class="wa-body-xs" href="https://www.npmjs.com/package/angular-awesome" style="color:var(--wa-color-brand-normal);" target="angular-awesome">
						<wa-icon family="brands" name="npm"></wa-icon>Angular Awesome
					</a>
					<a class="wa-body-xs" href="https://www.webawesome.com" style="color:var(--wa-color-brand-normal);" target="web-awesome">
						<wa-icon family="sharp-duotone" name="web-awesome"></wa-icon>Web Awesome
					</a>
					<a class="wa-body-xs" href="https://guicedee.com" style="color:var(--wa-color-brand-normal);" target="guicedee">
						<i class="fak fa-guicedee-logo built-on-logo"></i>GuicedEE
					</a>
				</div>
			</div>
		</nav>
		<div slot="aside">
			<router-outlet name="aside"></router-outlet>
		</div>
	</wa-page>
</ng-container>